module.exports = {"id":"204526","name":"Hervías","rating":"72","photo":"./data/images/photos/4/204526.png","club":{"name":"Real Valladolid","logo":"./data/images/clubs/RealValladolid.png"},"positions":["MD","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Hervias0.json
// module id = 1738
// module chunks = 0